import Map from "@arcgis/core/Map";
import esriConfig from "@arcgis/core/config";
import FeatureLayer from "@arcgis/core/layers/FeatureLayer";
import GraphicsLayer from "@arcgis/core/layers/GraphicsLayer";
import MapView from "@arcgis/core/views/MapView";
import BasemapGallery from "@arcgis/core/widgets/BasemapGallery";
import Expand from "@arcgis/core/widgets/Expand";
import Zoom from "@arcgis/core/widgets/Zoom";
import React, { useEffect, useRef } from "react";
import { createRoot } from "react-dom/client";
import { config } from "../../config";
import SearchComponents from "../SearchComponents/SearchComponents";

export const MapComponent: React.FC = () => {
  const mapDiv = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!mapDiv.current) return;

    esriConfig.apiKey = config.ESRI_API_KEY;

    const map: Map = new Map({
      basemap: "arcgis/topographic",
    });

    const view = new MapView({
      map: map,
      zoom: config.INIT_ZOOM,
      container: mapDiv.current,
      extent: config.EXTEND,
    });

    view.ui.remove("zoom");

    const zoomWidget = new Zoom({
      view: view,
    });
    view.ui.add(zoomWidget, "top-right");

    config.LAYERS.map((layer) => map.add(new FeatureLayer(layer as any))); //TODO any
    const graphicsLayer = new GraphicsLayer({
      title: "Search",
      listMode: "hide",
    });
    map.add(graphicsLayer);
    const graphicsLayerEdit = new GraphicsLayer({
      title: "Edit",
      id: "edit",
    });

    map.add(graphicsLayerEdit);

    const graphicsLayerDraw = new GraphicsLayer({
      title: "Draw",
      id: "draw",
    });

    map.add(graphicsLayerDraw);

    // const layerList = new LayerList({
    //   view: view,
    //   dragEnabled: true
    // });

    const basemapGallery = new BasemapGallery({
      label: "Basemap",
      view: view,
    });

    const bgExpand = new Expand({
      view: view,
      content: basemapGallery,
      collapseIcon: "add-and-update-features",
      expandTooltip: "Basemaps",
    });

    view.ui.add(bgExpand, "bottom-right");
    //view.ui.add(layerList, "top-left");

    // const searchExpandDiv = document.createElement("div");
    // searchExpandDiv.style.maxHeight = "80vh";
    // searchExpandDiv.style.overflowY = "auto";

    // view.ui.add(searchExpandDiv, "top-left");

    // const root = createRoot(searchExpandDiv);
    // root.render(<SearchComponents view={view} graphicsLayer={graphicsLayer} />);

    config.LAYOUT.elements.map((element) => {
      const divContainer = document.createElement("div");
      view.ui.add(divContainer, element.position);
      const divTree = createRoot(divContainer);
    
      divTree.render(
        React.createElement(element.component as React.FC<any>, {
          view: view,
          map: map,
        })
      );
    });

  
  }, []);

  return <div ref={mapDiv} style={{ height: "100vh", width: "100%" }}></div>;
};
